import * as React from 'react';
import { connect } from 'react-redux';
import IWhitepaperComponent from './IWhitepaperComponent';

import * as style from './WhitepaperComponentStyle.module.scss'

const WhitepaperComponent: React.SFC<IWhitepaperComponent> = (props) => {

  const documents = props.documents.filter((elem: any) => {
    return elem.type === 'whitepaper' && elem.file && !elem._destroy;
  }) ;
  const whitepaperLink = documents.length > 0 ? documents[0].file : null;

  const { userSignedIn, isUsInvestor } = props;
  return (
    whitepaperLink ? (
      <div className={style.investComponent}>
        {
          whitepaperLink &&
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={style.whitepaperBtn}
            href={whitepaperLink}
          >
            Download Whitepaper
          </a>
        }
      </div>
    ) : null
  );
};

const mapStateToProps = (store: any) => {
  return {
    documents: store.companyReducer.documents,
    slug: store.companyReducer.companyDetails.slug,
  };
};
export default connect(mapStateToProps)(WhitepaperComponent);
